import { mapGetters } from "vuex";

export const mapMethods = {
  computed: {
    ...mapGetters(["meets"])
  },
  methods: {
    deleteFacility(id) {
      let meetWithCurrentId = this.meets.edges.filter(
        e => +e.node.facilityId === +id
      );
      if (meetWithCurrentId.length > 0) {
        console.log("here");
        Promise.all(
          meetWithCurrentId.map(m =>
            this.$store.dispatch("deleteCurrentMeet", {
              meetId: +m.node.meetId
            })
          )
        )
          .then(() => {
            this.$toast.success(
              "All meets with current facility has been deleted."
            );
            this.$store
              .dispatch("removeFacility", {
                id: parseInt(id, 10)
              })
              .then(() => this.$toast.success("Facility has been deleted."))
              .catch(error => {
                console.error(error);
                this.$toast.error(
                  "Something went wrong with deleting current facility"
                );
              });
          })
          .catch(error => {
            console.error(error);
            this.$toast.error("Sorry, something went wrong.");
          });
      } else {
        this.$store
          .dispatch("removeFacility", {
            id: parseInt(id, 10)
          })
          .then(() => this.$toast.success("Facility has been deleted."))
          .catch(error => {
            console.error(error);
            this.$toast.error(
              "Something went wrong with deleting current facility"
            );
          });
      }
    }
  }
};
